import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {NotificationState} from "@/interfaces/state";
import {Notification, PostOffice} from "@/interfaces/entity";
import {
    createNotification, deleteNotification,
    listNotification,
} from "@/modules/notifications/services";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {NotificationParams} from "@/modules/notifications/params";
import { union } from "lodash";

@Module({ dynamic: true, name: "notification", store })
class NotificationModule extends VuexModule implements NotificationState {
    data: IdMapper<Notification> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: NotificationParams = new NotificationParams();

    @Mutation
    private UPDATE_NOTIFICATION_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_NOTIFICATION(payload: any) {
        const idMapper: IdMapper<Notification> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((notification: Notification,index: number) => {
            idMapper[notification.id!] = {...notification,stt:(index +1)} as any;
            return notification.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_NOTIFICATION(payload: Notification) {
        this.ids = union(this.ids, [payload.id]);
        this.data = { ...this.data, [payload.id]: payload }
    }

    @Mutation
    private DELETE_NOTIFICATION(payload: Notification) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.ids = this.ids.filter((id: number) => id !== payload.id);
        delete this.data[payload.id];
    }

    @Action({ rawError: true })
    public updateNotificationParams(payload: any) {
        this.UPDATE_NOTIFICATION_PARAMS(payload);
    }

    @Action({ rawError: true })
    public addNotification(payload: Notification) {
        this.SET_NOTIFICATION(payload);
    }

    @Action({ rawError: true })
    public async createNotification(form: any) {
        const { data } = await createNotification(form);
        this.SET_NOTIFICATION(data.data);
    }

    @Action({ rawError: true })
    public async listNotification(params: NotificationParams = new NotificationParams()) {
        const { data } = await listNotification(params);
        this.MAP_NOTIFICATION(data);
    }
    @Action({ rawError: true })
    public async deleteNotification(id: number) {
        const { data } = await deleteNotification(id);
        this.DELETE_NOTIFICATION(data.data);
    }
}

export const NotificationStore = getModule(NotificationModule);
